export const USER_PIN_PARAM = 'UserPin';

export class AesRequestModel {
    Form: string;
    Fields: number;
    Data: AesRequestFieldModel[];

    constructor(form: string, data: AesRequestFieldModel[], fields?: number) {
        this.Form = form;
        this.Fields = fields;
        this.Data = data;
    }

    toString(): string {
        let computedString = '';
        computedString += 'frm=' + encodeURIComponent(this.Form) + '&';
        if (this.Fields !== undefined && this.Fields === 0) {}
        else {
            let length = '0';

            if (this.Fields) {
                length = this.Fields.toString();
            } else if (this.Data.length > 0) {
                // Back requires the biggest field index so sort them and get the last
                length = this.Data
                    .filter(field => field.AESIndex !== '')
                    .sort((a, b) => parseInt(a.AESIndex, 10) - parseInt(b.AESIndex, 10))
                    .slice(-1)
                    .pop()
                    .AESIndex;
            }
            if(!this.Data[0]?.IsJson) {
                computedString += encodeURIComponent(this.Form + '_Fields') + '=' + length + '&';
            }
        }

        this.Data.map((field: AesRequestFieldModel) => {
            if (field.Param === 'UserPin') {
                computedString += encodeURIComponent('pin') + '=';
                computedString += encodeURIComponent(field.Value ?? '') + '&';
            } else {
                computedString += encodeURIComponent(this.Form + '_' + field.AESIndex) + '=';
                computedString += encodeURIComponent(field.Value ?? '') + '&';
            }
        });

        return computedString;
    }
}

export interface AesRequestFieldModel {
    Param: string;
    Value: string | number;
    AESIndex: string;
    IsJson?: boolean;
}
